import { Entity } from '@backstage/catalog-model';
import {
  ENVIRONMENT_ANNOTATION,
  ENDPOINT_LINK_TITLE,
  CODEBASE_LINK_TITLE,
  DEPLOYMENT_LINK_TITLE,
  DOCS_LINK_TITLE,
} from './config';

export function getEnvironment(entity: Entity): string | undefined {
  const raw = entity.metadata.annotations?.[ENVIRONMENT_ANNOTATION];
  return raw ? raw.toUpperCase() : undefined;
}

export function getOwnerRef(entity: Entity): string | undefined {
  return (entity.spec?.owner as string) ?? undefined;
}

export function getDependsOn(entity: Entity): string[] {
  const deps = entity.spec?.dependsOn;
  return Array.isArray(deps) ? (deps as string[]) : [];
}

function findLink(entity: Entity, title: string) {
  return entity.metadata.links?.find(
    link => link.title?.toLowerCase() === title.toLowerCase(),
  );
}

export function getCodebaseLink(entity: Entity) {
  return findLink(entity, CODEBASE_LINK_TITLE);
}

export function getDeploymentLink(entity: Entity) {
  return findLink(entity, DEPLOYMENT_LINK_TITLE);
}

export function getDocsLink(entity: Entity) {
  return findLink(entity, DOCS_LINK_TITLE);
}

export function getEndpointLink(entity: Entity) {
  return findLink(entity, ENDPOINT_LINK_TITLE);
}

export function getDisplayName(entity: Entity): string {
  return entity.metadata.title ?? entity.metadata.name;
}
